import { useState, useContext, useMemo } from 'react';
import MuiAppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import { styled, alpha } from '@mui/material/styles';
import Typography from '@mui/material/Typography';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';
import SearchIcon from '@mui/icons-material/Search';
import InputBase from '@mui/material/InputBase';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import { AuthContext } from "../../context/auth.context";
import { Button, InputAdornment, TextField } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Badge from '@mui/material/Badge';
import ListItemIcon from '@mui/material/ListItemIcon';
import LogoutIcon from '@mui/icons-material/Logout';
import { useMediaQuery } from '@mui/material';
import notification from "../../assets/icons/notification.png";
import flag from "../../assets/image/UK Flag.png";
import Profile from "../../assets/image/profile.png";
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import AuthContProvider from '../../context/auth.context';
import exp_prf from "../../assets/icons/exp_prf.png"
import smallscreenlogo from "../../assets/icons/logo.png"
import theme from '../../assets/theme';
import NotificationsNoneOutlinedIcon from '@mui/icons-material/NotificationsNoneOutlined';

const drawerWidth = 300;

const AppBar = styled(MuiAppBar, {
    shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
    zIndex: theme.zIndex.drawer + 3, // Increased from +1 to +3 to ensure it's above the drawer
    transition: theme.transitions.create(['width', 'margin'], {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
        marginLeft: drawerWidth,
        width: `calc(100% - ${drawerWidth}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
    }),
    [theme.breakpoints.down('sm')]: {
        height: "60px",
        padding: theme.spacing(1),
    },
}));

const StyledBadge = styled(Badge)(({ theme }) => ({
    '& .MuiBadge-badge': {
        backgroundColor: '#FBAE23',
        color: 'white',
        width: '20px',
        height: '20px',
        fontSize: '0.75rem',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        boxShadow: `0 0 2px ${theme.palette.background.default}`,
        transform: 'translate(50%, -50%)',
    },
}));

export default function MainAppBar(props) {
    const isMobile = useMediaQuery((theme) => theme.breakpoints.down('sm'));
    const isMediumScreen = useMediaQuery((theme) => theme.breakpoints.between('sm', 'md'));
    const [anchorEl, setAnchorEl] = useState(null);
    const [selanchor, setSelAnchorEl] = useState(null);
    const { logout, userDoc, locations, selLocation, setselLocation } = useContext(AuthContext);

    const handleClick = (event) => setAnchorEl(event.currentTarget);
    const handleClose = () => setAnchorEl(null);
    const handleLogout = () => {
        console.log('User logged out');
        handleClose();
        logout();
    };



    const handleSelection = (event) => setSelAnchorEl(event.currentTarget);
    const handleAnchorClose = () => setSelAnchorEl(null);

    const handleLanguageClick = (event) => setLanguageAnchorEl(event.currentTarget);
    const handleLanguageClose = () => setLanguageAnchorEl(null);

    const initialLetters = useMemo(() => {
        return selLocation.map(str =>
            str
                ?.trim()
                .split(/\s+/) // Handles multiple spaces
                .map(word => word.charAt(0))
                .join("")
                .toUpperCase()
        );
    }, [selLocation]);
    const getInitials = (name) =>
        name
            ?.trim()
            .split(" ")
            .map((n) => n[0])
            .join("")
            .toUpperCase();

    const userNameInitials = getInitials(userDoc.username);
    const userRoleInitials = getInitials(userDoc.role.name);
    console.log(userRoleInitials)

    return (
        <AppBar position="fixed" style={{ backgroundColor: theme.palette.light.main }} elevation={1}>
            <Toolbar sx={{
                paddingLeft: isMobile ? '8px' : '16px',
                paddingRight: isMobile ? '8px' : '16px',
                minHeight: isMobile ? '60px' : '64px'
            }}>
                {/* Logo */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                }}>
                    <img
                        src={smallscreenlogo}
                        alt="Logo"
                        style={{
                            height: isMobile || isMediumScreen ? '40px' : '70px', // Same height for mobile and medium
                            width: 'auto',
                            marginLeft: isMobile || isMediumScreen ? "0" : "-15px" // Adjust margin for medium
                        }}
                    />
                </Box>


              

                {/* Right side controls */}
                <Box sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: isMobile ? '8px' : '12px',
                    ml: 'auto'
                }}>
                    {/* Notification - Always visible */}
                    
                    <Button
                        size={isMobile ? 'small' : 'medium'}
                        onClick={handleSelection}
                        sx={{
                            color: theme.palette.primary.main,
                            display: 'flex',
                            alignItems: 'center',
                            textTransform: 'none',
                            minWidth: 'auto',
                            p: isMobile ? '4px' : '6px',
                            borderRadius: '8px',
                            backgroundColor: isMobile ? (theme.palette.dark.main) : 'transparent',
                        }}
                    >
                        {isMobile || isMediumScreen ? (
                            <Typography
                                variant="subtitle2"
                                sx={{
                                    fontWeight: 700,
                                    fontSize: '0.75rem',
                                    lineHeight: 1,
                                    px: 1,
                                    py: 0.5,
                                    borderRadius: '4px',
                                    backgroundColor: alpha(theme.palette.dark.main),
                                }}
                            >
                                {initialLetters.join(', ')}
                            </Typography>
                        ) : (
                            <>
                                <Typography
                                    variant="body2"
                                    sx={{
                                        fontWeight: 700,
                                        fontSize: '0.9375rem',
                                        mr: 1,
                                    }}
                                >
                                    {selLocation.join(', ')}
                                </Typography>
                                <img src={exp_prf} alt="Expand" style={{ width: '24px' }} />
                            </>
                        )}
                    </Button>

                    <Menu
                        anchorEl={selanchor}
                        open={Boolean(selanchor)}
                        onClose={handleAnchorClose}
                        PaperProps={{
                            sx: {
                                borderRadius: '8px',
                                minWidth: '180px',
                                mt: 1,
                                py: 0
                            },
                        }}
                    >
                        {locations.map((location, index) => (
                            <MenuItem
                                key={index}
                                onClick={() => {
                                    setselLocation(location);
                                    handleAnchorClose();
                                }}
                                sx={{
                                    py: 1.5,
                                    px: 2,
                                    '&:hover': {
                                        backgroundColor: alpha(theme.palette.primary.main, 0.1)
                                    }
                                }}
                            >
                                <Typography variant="body2">
                                    {location}
                                </Typography>
                            </MenuItem>
                        ))}
                    </Menu>

                    {/* User Profile */}
                    <Button
                        size={isMobile ? 'small' : 'medium'}
                        onClick={handleClick}
                        sx={{
                            color: theme.palette.primary.main,
                            display: 'flex',
                            alignItems: 'center',
                            textTransform: 'none',
                            minWidth: 'auto',
                            p: isMobile ? '4px' : '6px'
                        }}
                    >
                        {isMobile ? (
                            <Avatar
                                sx={{
                                    bgcolor: theme.palette.primary.main,
                                    width: 32,
                                    height: 32,
                                    fontSize: '0.875rem',
                                    fontWeight: 600
                                }}
                            >
                                {userNameInitials}
                            </Avatar>
                        ) : (
                            <>
                                <AccountCircleIcon style={{
                                    width: isMobile ? '32px' : '36px',
                                    height: isMobile ? '32px' : '36px'
                                }} />
                                <Box sx={{ ml: 1, textAlign: 'left', mr: 1 }}>
                                    <Typography
                                        variant="body2"
                                        sx={{
                                            fontWeight: "700",
                                            fontSize: isMediumScreen ? '0.875rem' : '0.9375rem',
                                            lineHeight: 1.2
                                        }}
                                    >
                                        {isMediumScreen ? userRoleInitials : userDoc.role.name}
                                    </Typography>
                                    <Typography
                                        variant="caption"
                                        sx={{
                                            fontWeight: "600",
                                            fontSize: '0.75rem',
                                            display: 'block'
                                        }}
                                    >
                                        {isMediumScreen ? userDoc.username : userDoc.username}
                                    </Typography>
                                </Box>
                                <img src={exp_prf} alt="Expand" style={{ width: '24px' }} />
                            </>
                        )}
                    </Button>

                    <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl)}
                        onClose={handleClose}
                        PaperProps={{
                            sx: {
                                borderRadius: '8px',
                                minWidth: '180px',
                                mt: 1,
                                py: 0
                            },
                        }}
                    >
                        <MenuItem
                            onClick={handleLogout}
                            sx={{
                                py: 1.5,
                                px: 2,
                                '&:hover': {
                                    backgroundColor: alpha(theme.palette.primary.main, 0.1)
                                }
                            }}
                        >
                            <ListItemIcon>
                                <LogoutIcon fontSize="small" />
                            </ListItemIcon>
                            <Typography variant="body2">
                                Logout
                            </Typography>
                        </MenuItem>
                    </Menu>
                </Box>
            </Toolbar>
        </AppBar>
    );
}